<template>
  <d-modal
    class="crm-new-popup order-popup"
    v-if="showModal"
    style="background-color: rgba(0,0,0,0.6)!important;"
    @close="closeModal">
    <d-modal-header :close="true">
      <d-modal-title>
        <h3 class="page-title">
          zamówienie klienta:
          <p class="text-success font-weight-light ml-2 mt-2">{{customer.name ? customer.name : ''}}</p>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div
        class="spinner-load"
        v-if="hidden_spinner === false">
        <div
          class="spinner-border spinner-border-sm crm-new-popup-spinner"
          role="status"></div>
      </div>
      <template v-else>
        <d-row>
          <d-col
            col
            sm="6">
            <h4
              class="pb-2 lign-middle"
              style="text-align: left">
              Dane zamówienia <d-button
                theme="primary"
                @click.native="$router.push('/zamowienia/edycja/' + data.id)"
                class="mr-2 action-button"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
            </h4>
          </d-col>
          <d-col
            col
            sm="6"
            class="text-right text-sm-right d-flex justify-content-end align-items-center">
            <span class="mr-4">Pobrane pojemniki: <span  class="text-info">{{ data.containers_number }}</span></span>
          </d-col>
        </d-row>

        <table class="table mt-0 mb-0 full-width">
          <thead class="bg-light">
            <tr>
              <th
                scope="col"
                class="border-0">Produkt</th>
              <th
                scope="col"
                class="border-0">Zamówienie</th>
              <th
                scope="col"
                class="border-0">Ważenie</th>
              <th
                scope="col"
                class="border-0">Wakowanie</th>
              <th
                scope="col"
                class="border-0">Kwota</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-if="arr.quantity !== '' && arr.price !== '0'"
              ref="product-cost"
              v-for="(arr, index) in data.products"
              :key="index">
              <td class="align-middle">
                {{ arr.product_name }}
              </td>
              <td class="align-middle">{{ arr.quantity }} <span>{{arr.product_unit !== 'KILOGRAM' ? 'szt' : 'kg' }}</span></td>
              <td class="align-middle"> <span v-if="arr.weighing_required === 1">{{ arr.weight }} <span>kg</span></span></td>
              <td class="align-middle">{{ arr.is_welding === 1 ? 'Tak' : 'Nie' }}</td>
              <td class="align-middle">{{ arr.price ? Number(arr.price).toFixed(2) : '0.00' }} zł</td>
            </tr>
            <tr
              v-if="arr.quantity === '' && index === '0'"
              v-for="(arr, index) in data.products"
              :key="index">
              <td
                colspan="5"
                class="text-center">
                Brak wprowadzonych produktów&hellip;
              </td>
            </tr>
          </tbody>
        </table>
        <div class="order-table-sum">
          <div class="label">Łącznia kwota:</div>
          <span>{{ confirm_sum ? confirm_sum.toFixed(2) : 0 }} zł</span>
        </div>
        <div
          v-if="!orderId"
          class="pb-3 pt-3 text-center">
          Trwa ładowanie danych&hellip;
        </div>
      </template>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils';
import OrdersFormPaymentConfirm from './OrdersFormPaymentConfirm';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'order-modal',
  components: { DatePicker, OrdersFormPaymentConfirm },
  data () {
    return {
      data: {
        id: 0,
        customer_id: '',
        products: [],
        price: '',
        containers_number: 0.0,
      },
      confirm_sum: 0,
      hidden_spinner: false,
      customer_id: '',
      customer: {},
      price: '',
      loaded: false,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    orderId: {
      type: [Object, Array, String, Number],
      required: true
    },
    customerId: {
      type: [Object, Array, String, Number],
      required: true
    },
  },
  mounted () {
    this.loaded = true;
    if (this.customerId) {
      this.loadCustomer(this.customerId);
    }
    if (this.orderId) {
      this.loadItemData(this.orderId);
    }
  },
  watch: {
    'orderId': function (id) {
      if (id) {
        this.loadItemData(id);
      }
    },
    'customerId': function (id) {
      if (id) {
        this.customer_id = id;
        this.loadCustomer(id);
      }
    },
    'data.id': function (value) {
      if (value && (this.orderId === this.data.id && this.loaded)) {
        this.hidden_spinner = true;
      }
    },
    'showModal': function (value) {
      if (value === true) {
        this.loadItemData();
      } else {
        this.clearDataAll();
      }
    },
  },
  methods: {
    closeConfirmModal () {
      this.closeModal();
      this.hidden_spinner = false;
    },
    clearData () {
      this.hidden_spinner = false;
      this.price = 0;
    },
    clearDataAll () {
      this.data.id = 0;
      this.data.price = 0;
      this.data.containers_number = 0.0;
      this.hidden_spinner = false;
      this.closeModal();
      this.hidden_spinner = false;
      this.loaded = false;
      this.customer_loaded = false;
    },
    loadCustomer (id) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/item/' + id,
        outputKey: 'customer',
        successAction: () => {
          this.updateSum();
        }
      });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/orders/item/',
        id: this.orderId,
        instanceFields: ['id', 'price', 'customer_id', 'shop_id', 'quantity', 'weight', 'products', 'containers_number', 'count', 'customer_name'],
        successAction: () => {
          if (this.orderId === this.data.id && this.showModal) {
            this.loaded = true;
            this.updateSum();
          }
        }
      });
    },
    updateSum () {
      this.confirm_sum = this.data.products.length > 0 ? (this.data.products.reduce((accumulator, product) => accumulator + Number(product.price), 0)) : 0;
    }
  },
  beforeDestroy () {
    this.clearDataAll();
  }
};
</script>
<style lang="scss">

  .modal-title {
    width: 100%;
  }
  .swal2-modal {
    border: 1px solid var(--form-border-color) !important;
    box-shadow: 0 0 17px 6px rgba(0,0,0,0.1);
  }
</style>
